import React, { useState } from 'react';
import axios from 'axios';
import "./login.scss";
import { useHistory } from 'react-router-dom';
import { API_URL } from '../../utils/Environment';
import Loader from '../../hooks/Loader';

const Login = ({ onLogin }) => {

    const [loader, setLoader] = useState(false);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const history = useHistory();

    const handleLogin = async () => {
        try {
            setLoader(true);
            const response = await axios.post(`${API_URL}auth/admins/signin`, {
                email,
                password
            });

            if (response.data) {

                // save token in localStorage/sessionStorage
                localStorage.setItem("token", response.data.data.token.accessToken);
                setLoader(false);
                onLogin();
                // redirect to dashboard
                history.push("/dashboard");
            } else {
                setLoader(false);
                setError("Invalid email or password");
            }
        } catch (err) {
            setLoader(false);
            setError("Something went wrong, please try again.");
            console.error(err);
        }
    };

    return (
        <>
            {loader && <Loader />}
            <section className='logon_main'>
                <img src='\assets\loginshade.png' className='img_shade' />
                <div className='custom-container'>
                    <div className='login_main'>
                        <img src='\assets\logo.svg' alt="logo" />
                        <h2>Log in to analytics account</h2>

                        <input
                            type="text"
                            placeholder='Enter email address'
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />

                        <input
                            type="password"
                            placeholder='Enter password'
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />

                        {error && <p className="text-danger mb-4">{error}</p>}

                        <button onClick={handleLogin}>Sign in</button>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Login;